import React from "react";

const Buttons = () => {
    return <button className="btn">Request Invite</button>;
};

export default Buttons;
